import React, { createContext, useContext, useState, useEffect, ReactNode, FC } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { customLog } from '../utils/utils';
import { customAxios } from '../lib/axios';

interface AuthContextType {
  profile: any;
  setProfile: (data: any) => void;
  isLoggedIn: boolean;
  isLoading: boolean;
  login: (accessToken: string, refreshToken: string) => void;
  logout: () => void;
  accessToken: string | null;
  refreshToken: string | null;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
  children: ReactNode;
}

// AuthProvider implementation
export const AuthProvider: FC<AuthProviderProps> = ({ children }) => {

  useEffect(() => {
    customLog("Checking user validity");
    // checkUserValidity();
    return () => {
      customLog("Cleaning up");
    };
  }, []);
  // const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [dataProfile, setDataProfile] = useState<any>()
  const [accToken, setAccToken] = useState<string>()
  const [refToken, setRefToken] = useState<string>()

  const navigate = useNavigate();

  const accessTokenStorage = localStorage.getItem('accessToken');
  const accessToken = accToken || accessTokenStorage

  const refresTokenStorage = localStorage.getItem('refreshToken');
  const refreshToken =  refToken || refresTokenStorage

  const isLoggedIn = !!accessToken

  useEffect(() => {
    checkUserValidity();
  }, []);

  const checkUserValidity = async () => {
    if (accessToken) {
      verifyToken(accessToken);
    } else {
      setIsLoading(false);
    }
  };

  const verifyToken = async (accessToken: string) => {
    await customAxios({
      method: "POST",
      url: `${process.env.REACT_APP_SERVER_URL}/api/v1/rms/auth/login/refresh/`,
      headers: {
        "Authorization": `Bearer ${accessToken}`,
      },
      data: { "refresh": localStorage.getItem('refreshToken') }
    }).then((response) => {
      if (response.status === 200) {
        customLog("Logged in");
        customLog(response.data);
        // setIsLoggedIn(true);
        if (window.location.pathname === '/login' && !!profile) {
          navigate('/');
        }
      } else {
        setAccToken(undefined)
        localStorage.removeItem('accessToken');
        // setIsLoggedIn(false);
      }
      setIsLoading(false);
    })
      .catch((error) => {
        console.error(error);
        localStorage.removeItem('accessToken');
        // setIsLoggedIn(false);
        setIsLoading(false);
      });
  };

  const login = async (accessToken: string, refreshToken: string) => {
    setAccToken(accToken)
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
    verifyToken(refreshToken);
  };

  const logout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('profile');
    setDataProfile(undefined)
    setAccToken(undefined)
    window.location.href = '/login'; // Handle full redirect to clean the state and reducer
    // setIsLoggedIn(false);
  };

  const localStorageProfile = !!localStorage.getItem('profile') ? JSON.parse(localStorage.getItem('profile') || '') : undefined
  const profile = dataProfile || localStorageProfile

  const setProfile = (data: any) => {
    setDataProfile(data)
    localStorage.setItem('profile', JSON.stringify(data))
  }

  return (
    <AuthContext.Provider value={{ isLoggedIn, isLoading, login, logout, setProfile, profile, accessToken, refreshToken }}>
      {!isLoading && children}
    </AuthContext.Provider>
  );
};

// Custom hook to use the AuthContext
export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
